@if (isOpen) {
  <div #scannerOverlay class="sm-qr-scanner-overlay" role="dialog" aria-modal="true" (click)="handleBackdropClick()">
    <div class="sm-qr-scanner-overlay__shell" (click)="$event.stopPropagation()">
      <header class="sm-qr-scanner-overlay__header">
        <div class="sm-qr-scanner-overlay__titles">
          <h2 class="sm-qr-scanner-overlay__title">{{ title }}</h2>
          @if (hint) {
            <p class="sm-qr-scanner-overlay__hint">{{ hint }}</p>
          }
        </div>

        <button
          type="button"
          class="sm-qr-scanner-overlay__close"
          [attr.aria-label]="closeAriaLabel || null"
          (click)="handleCloseClick()">
          <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
        </button>
      </header>

      <div class="sm-qr-scanner-overlay__viewport">
        <video #video class="sm-qr-scanner-overlay__video" [style.visibility]="externalError ? 'hidden' : null" muted autoplay playsinline></video>
        <div #overlay class="sm-qr-scanner-overlay__overlay" [hidden]="!!externalError"></div>

        @if (externalScanner ? externalLoading : isStarting) {
          <div class="sm-qr-scanner-overlay__message">{{ loadingLabel }}</div>
        }

        @if (externalScanner ? externalError : isSupported === false) {
          <div class="sm-qr-scanner-overlay__message sm-qr-scanner-overlay__message--error">
            <p role="alert">{{ externalScanner ? externalError : (errorMessage || unsupportedLabel) }}</p>
            @if (externalScanner && retryLabel) {
              <div class="sm-qr-scanner-overlay__actions">
                <sm-action-button variant="secondary" (click)="handleCloseClick()">{{ closeAriaLabel }}</sm-action-button>
                <sm-action-button [disabled]="externalLoading" (click)="retryRequested.emit()">{{ retryLabel }}</sm-action-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
